import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { HotelResultsLayout } from '@shared/models/hotel-results-layout.model';
import { HOTEL_LAYOUT } from 'app.config';
import { filter, map, tap } from 'rxjs/operators';
import * as fromActions from '../actions/hotel.actions';

@Injectable()
export class HotelEffects implements OnInitEffects {
  constructor(private actions$: Actions) {}

  public ngrxOnInitEffects(): Action {
    return new fromActions.RestoreHotelResultsLayout();
  }

  public restoreHotelLayout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.RESTORE_HOTEL_RESULTS_LAYOUT),
      map(() => localStorage.getItem(HOTEL_LAYOUT)),
      filter((hotelLayout) => !!hotelLayout),
      map((hotelLayout) => new fromActions.RestoreHotelResultsLayoutSuccess(<HotelResultsLayout>hotelLayout))
    )
  );

  public saveHotelLayout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.SET_HOTEL_RESULTS_LAYOUT_SUCCESS),
        tap((action: fromActions.SetHotelLayoutSuccess) => {
          localStorage.setItem(HOTEL_LAYOUT, action.payload);
        })
      ),
    { dispatch: false }
  );
}
